import React from 'react';

const Header = ({ isMobile, isSidebarOpen, setIsSidebarOpen, pageTitle = 'Dashboard' }) => {
    return (
        <nav style={{
            background: 'linear-gradient(135deg, #238548 0%, #97d6ac 100%)',
            color: '#ffffff',
            padding: isMobile ? '0.75rem 1rem' : '1.5rem 4rem',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            position: 'fixed',
            top: 0,
            right: 0,
            left: isMobile ? 0 : '280px',
            width: isMobile ? '100%' : 'calc(100% - 280px)',
            zIndex: 1000,
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            transition: 'all 0.3s ease',
            minHeight: isMobile ? '60px' : '140px'
        }}>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: isMobile ? '0.75rem' : '2rem'
            }}>
                <img
                    src="/logo.png"
                    alt="Swami Vivekananda University Logo"
                    style={{
                        width: isMobile ? '40px' : '120px',
                        height: isMobile ? '40px' : '120px',
                        objectFit: 'contain'
                    }}
                />

                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '1.5rem'
                }}>
                    <h1 style={{
                        fontSize: isMobile ? '1rem' : '1.8rem',
                        fontWeight: 'bold',
                        margin: 0,
                        whiteSpace: 'nowrap'
                    }}>
                        Swami Vivekananda University
                    </h1>
                    <p style={{
                        fontSize: '1rem',
                        margin: 0,
                        opacity: 0.9,
                        borderLeft: '2px solid rgba(255, 255, 255, 0.5)',
                        paddingLeft: '1.5rem',
                        whiteSpace: 'nowrap',
                        display: isMobile ? 'none' : 'block'
                    }}>
                        {pageTitle}
                    </p>
                </div>
            </div>

            <button
                onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                style={{
                    display: isMobile ? 'flex' : 'none',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'none',
                    border: 'none',
                    color: '#ffffff',
                    fontSize: '1.2rem',
                    cursor: 'pointer',
                    padding: '0.5rem',
                    borderRadius: '8px'
                }}
            >
                {isSidebarOpen ? '✕' : '☰'}
            </button>
        </nav>
    );
};

export default Header;
